import api from '../services/api';

export const getDashboardData = async () => {
  try {
    // API interceptor automatically handles masquerading headers
    const response = await api.get('/api/dashboard');
    
    if (response.data.status === 1 && response.data.data) {
      return {
        success: true,
        dashboardType: response.data.data.dashboard_type,
        data: response.data.data
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch dashboard data');
    }
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    
    // Determine error type and provide appropriate message
    let errorMessage = 'Failed to fetch dashboard data';
    let errorType = 'server';
    
    if (error.code === 'NETWORK_ERROR' || 
        error.message?.includes('Network Error') ||
        error.message?.includes('ERR_NETWORK') ||
        error.message?.includes('ERR_INTERNET_DISCONNECTED') ||
        error.message?.includes('timeout') ||
        error.message?.includes('fetch')) {
      errorMessage = 'Network Error - Unable to connect to server';
      errorType = 'network';
    } else if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      if (status >= 500) {
        errorMessage = 'Server Error - Please try again later';
        errorType = 'server';
      } else if (status === 404) {
        errorMessage = 'Dashboard service not found';
        errorType = 'server';
      } else if (status === 403) {
        errorMessage = 'Access denied - insufficient permissions';
        errorType = 'auth';
      } else if (status === 401) {
        errorMessage = 'Authentication required - please log in again';
        errorType = 'auth';
      } else {
        errorMessage = error.response.data?.message || `Server error (${status})`;
        errorType = 'server';
      }
    } else if (error.request) {
      // Request was made but no response received
      errorMessage = 'Network Error - No response from server';
      errorType = 'network';
    } else {
      // Something else happened
      errorMessage = error.message || 'Unknown error occurred';
      errorType = 'unknown';
    }
    
    return {
      success: false,
      error: errorMessage,
      errorType: errorType
    };
  }
};

export const getChatReportsData = async (params = {}) => {
  try {
    // Use the same dashboard API but with chat reports specific parameters
    const response = await api.get('/api/dashboard', { 
      params: { 
        type: 'chat_reports',
        ...params 
      }
    });
    
    if (response.data.status === 1 && response.data.data) {
      return {
        success: true,
        data: response.data.data
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch chat reports data');
    }
  } catch (error) {
    console.error('Error fetching chat reports data:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch chat reports data'
    };
  }
};

export const getChatAnalyticsData = async (params = {}) => {
  try {
    // Use the same dashboard API but with analytics specific parameters
    const response = await api.get('/api/dashboard', { 
      params: { 
        type: 'chat_analytics',
        ...params 
      }
    });
    
    if (response.data.status === 1 && response.data.data) {
      return {
        success: true,
        data: response.data.data
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch chat analytics data');
    }
  } catch (error) {
    console.error('Error fetching chat analytics data:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch chat analytics data'
    };
  }
};